import { render, staticRenderFns } from "./CampaignIntegrationMatchSettings.vue?vue&type=template&id=a016e830&"
import script from "./CampaignIntegrationMatchSettings.vue?vue&type=script&lang=js&"
export * from "./CampaignIntegrationMatchSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports